var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import styled from "styled-components";
import { Text } from "../../Text";
import { Dropdown } from "../../Menu/Dropdown";
import { ChevronDownIcon } from "../../Icons/ChevronDownIcon";
var GlobalNavDropdownStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: auto;\n  min-width: 200px;\n  & .bn-title,\n  & .bn-chevron-down-icon {\n    position: relative;\n  }\n  & .bn-chevron-down-icon {\n    cursor: pointer;\n  }\n  & .bn-title {\n    margin: unset;\n    line-height: 42px; // require for aligning to logo bottom\n  }\n"], ["\n  display: block;\n  width: auto;\n  min-width: 200px;\n  & .bn-title,\n  & .bn-chevron-down-icon {\n    position: relative;\n  }\n  & .bn-chevron-down-icon {\n    cursor: pointer;\n  }\n  & .bn-title {\n    margin: unset;\n    line-height: 42px; // require for aligning to logo bottom\n  }\n"])));
var GlobalNavDropdown = function (_a) {
    var applicationName = _a.applicationName, children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    var _b = __read(React.useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var ref = React.useRef(null);
    var toggleMenu = React.useCallback(function () {
        setIsOpen(!isOpen);
    }, [isOpen, setIsOpen]);
    var triggerClick = React.useCallback(function (event) {
        event.keyCode === 13 && event.currentTarget.click();
    }, []);
    return (React.createElement(GlobalNavDropdownStyle, { id: id, className: className, style: style },
        React.createElement(Text, { className: "bn-title", color: "light", variant: "appName", tabIndex: 0, ref: ref, onKeyUp: triggerClick, onClick: toggleMenu },
            applicationName,
            " ",
            React.createElement(ChevronDownIcon, { className: "bn-chevron-down-icon", iconColor: "primaryLight", size: "small" })),
        React.createElement(Dropdown, { onRequestClose: toggleMenu, anchorEl: ref.current, isOpen: isOpen }, children)));
};
export default GlobalNavDropdown;
var templateObject_1;
//# sourceMappingURL=GlobalNavDropdown.js.map